import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const StartPointDiamondIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 8" fill="none">
      <path d="M15.4286 4.00366H6.28573" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.42862 1.14648L6.28577 4.00363L3.42862 6.86077L0.571481 4.00363L3.42862 1.14648Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
